// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3tkRK","title":"FrontImage_title__3j44r"};